import styles from './styles.module.css';
import Image from 'next/image';

import logo_chippu_place from '@/assets/logo_chippu_place.svg';
import { IconeBusca } from '@/components/atoms/Icones/IconeBusca';
import { IconePessoa } from '@/components/atoms/Icones/IconePessoa';
import { theme } from '@/styles/theme';
import Header, { HeaderProps } from '@/components/atoms/Header';
import { IconeSacola } from '@/components/atoms/Icones/IconeSacola';
import { IconeAjuda } from '@/components/atoms/Icones/IconeAjuda';
import Text from '@/components/atoms/Text';

export default function CabecalhoHomeFallback(props: HeaderProps) {
  return (
    <Header
      {...props}
      $style={{
        paddingTop: 0,
        paddingBottom: 0,
        flexDirection: 'row',
        flex: 1,
        justifyContent: 'center',
      }}
    >
      <div
        className={styles.toolbar}
        style={{
          padding: `${theme.spacing[4]}px ${theme.spacing[6]}px`,
          gap: theme.spacing[6],
        }}
      >
        <Image
          src={logo_chippu_place}
          alt="Chippu Place logo"
          height={theme.typography.font.size[7]}
          priority
        />
        <div
          className={styles.campoBuscaContainer}
          style={{
            padding: theme.spacing[2],
            borderRadius: theme.spacing[2],
            gap: theme.spacing[1],
            backgroundColor: theme.tokens.colors.surface,
            border: `2px solid ${theme.colors.neutral.neutral_alpha[5]}`,
          }}
        >
          <IconeBusca
            size={theme.typography.font.size[3]}
            color={theme.colors.neutral.neutral_alpha[9]}
          />
          <input
            className={styles.campoBusca}
            placeholder="Buscar por produtos, planos e ofertas"
            style={{
              paddingRight: theme.spacing[1],
              paddingLeft: theme.spacing[1],
            }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            gap: theme.spacing[2],
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#eeeeeeff',
              width: 40,
              height: 40,
              borderRadius: '50%',
            }}
          >
            <IconePessoa
              size={theme.typography.font.size[6]}
              color={theme.tokens.colors.black_contrast}
            />
          </div>
          <div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: theme.spacing[1],
              }}
            >
              <Text
                $size={2}
                $color="neutral"
                $weight="bold"
                $align="left"
                $highContrast={true}
                $text="Entre"
              />
              <Text
                $size={2}
                $color="neutral"
                $weight="medium"
                $align="left"
                $highContrast={true}
                $text="ou"
              />
            </div>

            <Text
              $size={2}
              $color="neutral"
              $weight="bold"
              $align="left"
              $highContrast={true}
              $text="Cadastre-se"
            />
          </div>
        </div>
        <div style={{ padding: theme.spacing[1] }}>
          <IconeAjuda
            size={theme.typography.font.size[6]}
            color={theme.colors.neutral.neutral[12]}
          />
        </div>

        <div style={{ padding: theme.spacing[1] }}>
          <IconeSacola
            size={theme.typography.font.size[6]}
            color={theme.colors.neutral.neutral[12]}
          />
        </div>
      </div>
    </Header>
  );
}
